// Source
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelPayee from "../../model/custom/Payee";

export const createData = (
    clientId: number,
    bankName: string,
    branchName: string,
    bankCode: string,
    branchCode: string,
    accountTypeId: number,
    acNumber: string,
    accountName: string,
    accountNameKanji: string,
    swift: string,
    url: string,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        client_id: clientId,
        bank_name: bankName,
        branch_name: branchName,
        bank_code: bankCode,
        branch_code: branchCode,
        account_type_id: accountTypeId,
        ac_number: acNumber,
        account_name: accountName,
        account_name_kanji: accountNameKanji,
        swift,
        url,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payee/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (
    id: number,
    clientId: number,
    bankName: string,
    branchName: string,
    bankCode: string,
    branchCode: string,
    accountTypeId: number,
    acNumber: string,
    accountName: string,
    accountNameKanji: string,
    swift: string,
    url: string,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        client_id: clientId,
        bank_name: bankName,
        branch_name: branchName,
        bank_code: bankCode,
        branch_code: branchCode,
        account_type_id: accountTypeId,
        ac_number: acNumber,
        account_name: accountName,
        account_name_kanji: accountNameKanji,
        swift,
        url,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/payee/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/payee/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/payee/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelPayee.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        bank_name: dataMain.bank_name,
        branch_name: dataMain.branch_name,
        client_id: dataMain.client_id as unknown as string,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/payee/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/payee/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
